'use strict';

var styled = require('styled-components');

const hourglass = styled.keyframes `
  0% {
    transform: rotate(0deg);
  }
  25%, 50% {
    transform: rotate(180deg);
  }
  75%, 100% {
    transform: rotate(360deg);
  }
`;
const animations = {
    hourglass,
};
const transitionFunctions = {
    easeFn: 'ease-in-out',
};
const transitionTimings = {
    fast: '0.15s',
    medium: '0.3s',
};
const transition = {
    functions: transitionFunctions,
    timings: transitionTimings,
};

exports.animations = animations;
exports.transition = transition;
//# sourceMappingURL=animations.js.map
